// extracted by mini-css-extract-plugin
export default {"CommentBox":"Shared-module__CommentBox__QRnhHmO","Condensed":"Shared-module__Condensed__l1jAwOM"};